import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetBusinessCaseQuery, useGetSaleBusinessCasePricesOverviewQuery} from '@dms/api/sales';
import {useGetSaleVehicleQuery} from '@dms/api/vehicle';

interface UseBusinessCaseSaleVehicleDataProps {
  businessCaseId: string;
  saleVehicleId: string;
}

export function useBusinessCaseSaleVehicleData(props: UseBusinessCaseSaleVehicleDataProps) {
  const {
    data: saleVehicleData,
    isLoading: isSaleVehicleLoading,
    isError: isSaleVehicleError,
  } = useGetSaleVehicleQuery(
    {vehicleId: props.saleVehicleId},
    {skip: isNilOrEmpty(props.saleVehicleId)}
  );

  const {
    data: saleVehiclePrices,
    isLoading: isPricesLoading,
    isError: isPricesError,
  } = useGetSaleBusinessCasePricesOverviewQuery({businessCaseId: props.businessCaseId});

  const {
    data: businessCaseData,
    isLoading: isBusinessCaseLoading,
    isError: isBusinessCaseError,
  } = useGetBusinessCaseQuery({businessCaseId: props.businessCaseId});

  return {
    saleVehicleData,
    saleVehiclePrices,
    businessCaseData,
    isLoading: isSaleVehicleLoading || isPricesLoading || isBusinessCaseLoading,
    isError: isSaleVehicleError || isPricesError || isBusinessCaseError,
  };
}
